import Layout from "../components/Layout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {createSearchParams, useNavigate} from "react-router-dom";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {ProgressSpinner} from "primereact/progressspinner";
import QuarterNames from "../components/QuarterNames";
import { MultiSelect } from "react-multi-select-component";

const cssVars={
    '--rmsc-h': 15
}

const HODUserMarks = () => {
    const [start] = useState(0);
    const [empList, setEmpList] = useState([]);
    const {user} = useSelector((state) => state["auth"]);
    const navigate = useNavigate();
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [factoryData, setFactoryData] = useState([])
    const [departmentData, setDepartmentData] = useState([])
    const [designationData, setDesignationData] = useState([])
    const [quarterNames, setQuarterNames] = useState([]);
    const [monthNames,setMonthNames]=useState([]);
    const [selected, setSelected] = useState([]);
    const [getFilterData, setGetFilterData] = useState([]);

    useEffect(() => {
        initFilters();
        GetEmployeeFilterData()
        getEmployeeList(user.registerID,user.quarterID);
        GetSubmittedQuarterNames(user.registerID);
        GetAllMonthList();
    }, [])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const GetAllMonthList = () => {
        axios.post(BASE_URL + `/api/utility/GetAllMonth`)
            .then((response) => {
                //console.log(response);
                setMonthNames(
                    response.data.map((record) => {
                        return {
                            value: record.monthID,
                            label: record.monthName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const GetSubmittedQuarterNames = (id) => {
        axios
            .post(BASE_URL + `/api/dashboard/GetSubmittedQuarterNames/${id}`)
            .then((response) => {
                setQuarterNames(
                    response.data.map((record) => {
                        return {
                            value: record.quarterID,
                            label: record.quarterName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const GetEmployeeFilterData = () => {
        axios.get(BASE_URL + "/api/report/GetFilterFactoryData")
            .then(response => {
                setFactoryData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDepartmentData")
            .then(response => {
                setDepartmentData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDesignationData")
            .then(response => {
                //console.log(response.data);
                setDesignationData(response.data)
            })
            .catch(console.error)
    }

    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'roleName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue('');
    }

    const clearFilter = () => {
        initFilters();
    }

    const getEmployeeList = (id,quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID : parseInt(quarterID)
        }
        //axios.post(BASE_URL + "/api/report/GetFilterData", JSON.stringify(data))
        setIsLoading(true);
        axios.post(BASE_URL + "/api/utility/GetUserMarksForHOD", JSON.stringify(data))
            .then(response => {
                setEmpList(response.data)
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                console.log(error);
             });
    }

    // const _actionBody = (empIdp) => (<>
    //   <button type="button" style={{cursor: "pointer",padding:"2px 5px 2px 5px", fontSize:"10pt"}} className="btn btn-outline-secondary" onClick={()=>{
    //       navigate({
    //           pathname: "/MarksDetails",
    //           search: createSearchParams({
    //               employeeId: empIdp.registerID
    //           }).toString()
    //       });
    //   }}>Details</button>
    // </>)

    const _actionEmployee = (empIdp) => (<>
    
    <span style={{cursor: "pointer"}} className="txtBlue" onClick={()=>{
        navigate({
            pathname: "/MarksDetails",
            search: createSearchParams({
                employeeId: btoa(empIdp.registerID),
                quarterID: btoa(document.getElementById('ddlQuarter').value==="-1"? user.quarterID : document.getElementById('ddlQuarter').value)
            }).toString()
        });
    }}>{empIdp.employeeName}</span>
  </>)

const skillWillMatrixMarks = ({skillMark}) => (<>
    { <span>
        {Number(skillMark) >= 20 ? 
            <span class="product-badge status-complete disBlock" style={{padding:"0px"}}>{skillMark}</span> :
            <span class="product-badge status-incomplete disBlock" style={{padding:"0px"}}>{skillMark}</span>
        }
    </span> }
    
</>
)

const childToParent = () => {
    //alert(document.getElementById('ddlQuarter').value);
    getEmployeeList(user.registerID,document.getElementById('ddlQuarter').value);
    //GetDashboardSummaryData(document.getElementById('ddlQuarter').value);
  }
  const downloadUserMarks = () => {
    //var e = document.getElementById("ddlQuarter");
    //var _selectedValue = e.value==="-1"?user.quarterID:e.value;
    getEmployeeUserMarks(user.registerID);
}
const getEmployeeUserMarks=(id)=>{    
    window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/DownloadUserMarksForHOD?SearchStr="+btoa("RegisterID=" + id));
    //window.open("http://localhost:13805/PMSReport/DownloadUserMarksForHOD?SearchStr="+btoa("RegisterID=" + id));
}   

const header = (
    <div className="table-header">
        <div className='d-flex justify-content-between'>
            <div>
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter}/>
                <span className="p-input-icon-left"> <i className="pi pi-search"/>
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                           placeholder="Keyword Search"/>
            </span>                
            </div>
            <div className="col-2">
                        <button className="btn btn-primary btn-sm float-end" onClick={downloadUserMarks}><i class="bi bi-chevron-double-down"></i> Download</button>
                    </div>

            {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""}
        </div>
    </div>
);

let headerGroup = 
    <ColumnGroup>
    <Row>
        <Column header="Basic Information" colSpan={6} className="tdCenterColumnSpan" />
        <Column header="Self Assessment" colSpan={2} className="tdCenterColumnSpan" />
        <Column header="Supervisor Assessment" colSpan={3} className="tdCenterColumnSpan" />
        <Column header="Summary" colSpan={3} className="tdCenterColumnSpan"/>
        <Column header="Promotion Recommendation" colSpan={4} className="tdCenterColumnSpan"/>
    </Row>
    <Row>
        <Column header="Last Year" sortable field="registerID" hidden={true}/>
        <Column header="Quarter" sortable field="quarterID"/>
        <Column header="Emp Code" sortable field="employeeCode"/>
        <Column header="Name" sortable field="employeeName"/>
        <Column header="Department" sortable field="department"/>
        <Column header="Designation" sortable field="designation"/>
        <Column header="Role Name" sortable field="roleName"/>

        <Column header="Core Values" sortable field="selfAssesmentMark"/>
        <Column header="Core Competency" sortable field="selfCompetencyMark"/>

        <Column header="Core Values" sortable field="supervisorAssesmentMark"/>
        <Column header="Core Competency" sortable field="supervisorCompetencyMark"/>
        <Column header="Skill Will Matrix" sortable field="skillMark"/>        

        <Column header="Obtained" sortable field="totalMark"/>
        <Column header="Total Mark" sortable field="grandTotalMark"/>
        <Column header="Percentage(%)" sortable field="totalPercentage"/>

        <Column header="Supervisor Recommendation" sortable field="skillMark"/>
        <Column header="HOD Recommendation" sortable field="skillMark"/>
        <Column header="Unit head Recommendation" sortable field="skillMark"/>
        <Column header="HR Comment" sortable field="skillMark"/>

        {/* <Column header="" field="registerID"/> */}
    </Row>
    
    </ColumnGroup>;

    return (<Layout>

        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">           
            </div>
            <div className="card-body" style={{overflow:'scroll'}}>
                <DataTable id="tblEmpMarksSummary" 
                header={header}
                value={empList} 
                paginator 
                resizableColumns
                headerColumnGroup={headerGroup} 
                filters={filters}
                dataKey="registerID"
                filterDisplay="menu"
                globalFilterFields={['quarterName','employeeCode','employeeName', 'department', 'designation','roleName']}
                rows={10} first={start}
                           paginatorTemplate="PageLinks">
                    <Column field="registerID" header="registerID" hidden={true}/>
                    <Column field='quarterName' header="Quarter"/>
                    <Column field='employeeCode' header="Employee Code"/>
                    <Column field='employeeName' header="Employee Name"  body={_actionEmployee}/>
                    <Column field='department' header="Department"/>
                    <Column field='designation' header="Designation"/>
                    <Column field="roleName" header="Role Name" />

                    <Column field='selfAssesmentMark' header="Assesment" className="tdDataCenter"/>
                    <Column field='selfCompetencyMark' header="Competency" className="tdDataCenter"/>

                    <Column field='supervisorAssesmentMark' header="SupervisorAssesmentMark" className="tdDataCenter"/>                    
                    <Column field='supervisorCompetencyMark' header="SupervisorCompetencyMark" className="tdDataCenter"/>
                    <Column field='skillMark' header="Skill Matrix" className="tdDataCenter" body={skillWillMatrixMarks}/>                   
                    <Column header="Obtained" className="tdDataCenter" sortable field="totalMark"/>
                    <Column header="Grand Total Mark" className="tdDataCenter" sortable field="grandTotalMark"/>
                    <Column header="Percentage(%)" className="tdDataCenter" sortable field="totalPercentage"/>
                    <Column header="SupervisorRecommendation" className="tdDataCenter" sortable field="recommendationStatusDetail"/>
                    <Column header="HODRecommendation" className="tdDataCenter" sortable field="hodRecommendationStatusDetail"/>
                    <Column header="DivisionHeadRecommendation" className="tdDataCenter" sortable field="divisionHeadRecommendationStatusDetail"/>
                    <Column header="HRComment" className="tdDataCenter" sortable field="hrComment"/>
                    {/* <Column field="registerID" className="tdDataCenter" header="Action" body={_actionBody}/> */}
                </DataTable>
            </div>
        </div>

    </Layout>)
}


export default HODUserMarks